module.exports = __webpack_public_path__ + "img/54.425f30d8.png";